import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginButtonComponent } from './login-button.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
    declarations: [LoginButtonComponent],
    exports: [
        LoginButtonComponent
    ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
  ],
})
export class LoginButtonModule { }
